
import { useDispatch, useSelector } from 'react-redux';
import { useState } from "react";

import {Grid, Typography, Button, Box } from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles } from '@mui/styles';
import Alert from '@mui/material/Alert';
import {AlertTitle} from "@mui/material";

import leap from 'assets/leap.jpeg';
import {setSuccessAction} from '../redux/actions/getFormActions';

const useStyles = makeStyles({
    success_logo: {
        borderRadius: '50px !important',
        width: '250px',
        height: '250px',
        backgroundColor: "#f0c2c254",
        padding: 5,
        marginRight: '23px'
    },
    progressbar: {
        width: '250px',
        height: '15px !important',
        borderRadius: '10px'
    }
  });

const Success = () => {
    const classes = useStyles();
    const formData = useSelector(state => state.formData);
    const dispatch = useDispatch();
    const [animation, setAnimation] = useState(true);
    setTimeout(() => {
        setAnimation(false)
    }, 10000);

    return (
        <Box sx={{borderRadius: '5px'}}>
            <Grid item className="p-4">
                <Grid container justifyContent="center" direction="column" alignContent="center">
                    <img src={leap} className={classes.success_logo} />
                    { formData.success.status === 'loading' && <LinearProgress className={classes.progressbar}/>}
                </Grid>
                {formData.success.status === 'success' &&
                    <>
                        <Grid className="mt-3">
                            <Typography color="primary" variant="h6" align="center" className="py-1">
                                    Please enter this into your property management system.
                            </Typography>
                            <Typography color="primary" variant="h6" align="center" className="py-1">
                                Leap Landlord ID:  <b>{formData.success.value}</b>
                            </Typography>
                        </Grid>
                    </>
                }
                {formData.success.status === 'error' && formData.success !== 'loading' &&
                    <>
                        <Alert
                            onClose={() => dispatch(setSuccessAction(null))}
                            severity="error"
                        >
                            <AlertTitle>Error</AlertTitle>
                            {formData.success.value}
                        </Alert>
                        {/* <Grid container justifyContent="center">
                            <Button onClick={() => dispatch(setSuccessAction(null))} variant="contained">Ok</Button>
                        </Grid> */}
                    </>
                }
            </Grid>
        </Box>
    )
}

export default Success;